import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {DefaultLayoutComponent} from "../container/default-layout/default-layout.component";
import {AuthRouter} from "../authentication/service/auth.router";
import {HomePageComponent} from "./views/home-page/home-page.component";
import {CustomerListComponent} from "./views/cooperative/customer-list/customer-list.component";
import {CooperativeGuard} from "../service/cooperative-guard.service";
import {CooperativeListComponent} from "./views/cooperative/cooperative-list/cooperative-list.component";
import {AdminGuard} from "../service/admin-guard";
import {MeterDataComponent} from "./views/cooperative/meter-data/meter-data.component";
import {UserGuard} from "../service/user-guard.service";
import {StationListComponent} from "./views/cooperative/station-list/station-list.component";
import {PrivacyPolicyComponent} from "./views/privacy-policy/privacy-policy.component";

const routes: Routes = [
  {
    path: 'chinh-sach-bao-mat',
    component: PrivacyPolicyComponent,
    data: {
      title: 'Chính sách bảo mật'
    }
  },
  {path: 'meter-cooperative', redirectTo: 'meter-cooperative/home'},
  {
    path: 'meter-cooperative',
    component: DefaultLayoutComponent,
    canActivate: [AuthRouter],
    canActivateChild: [AuthRouter],
    data: {
      title: 'Quản lý HTX'
    },
    children: [
      {
        path: 'home',
        component: HomePageComponent,
        data: {title: 'Trang chủ'}
      },
      {
        path: 'cooperative',
        component: CooperativeListComponent,
        canActivate: [AdminGuard],
        data: {title: 'Quản lý HTX'}
      },
      {
        path: 'cooperative/:cooperativeNo',
        component: StationListComponent,
        canActivate: [CooperativeGuard],
        canActivateChild: [CooperativeGuard],
        data: {title: 'Quản lý Trạm'},
      },
      {
        path: 'cooperative/:cooperativeNo/station/:stationNo/customer',
        component: CustomerListComponent,
        canActivate: [CooperativeGuard],
        canActivateChild: [CooperativeGuard],
        data: {title: 'Danh sách KH'},
      },
      {
        path: 'cooperative/:cooperativeNo/station/:stationNo/customer/:customerNo',
        component: MeterDataComponent,
        canActivate: [UserGuard],
        canActivateChild: [UserGuard],
        data: {title: 'Chỉ số công tơ KH'},
      }
    ]
  },
  {path: '', redirectTo: 'meter-cooperative/home', pathMatch: 'full'},
  {path: '**', redirectTo: 'meter-cooperative/home'}
];

export const AppRoutingModule = RouterModule.forRoot(routes);
